import AppointmentAttendanceEvent from './AppointmentAttendanceEvent';

export default AppointmentAttendanceEvent;
